module.exports = __webpack_public_path__ + "img/DAY5-2.617c2d3c.jpg";